import {useEffect, useRef, useState} from 'react';
import {useDispatch} from 'react-redux';
import {fetchDepartmentList} from 'web/redux/actions/DepartmentActions';

export const useDepartmentListModalControl = (setNeedSearchLoad) => {
  const dispatch = useDispatch();
  const departmentListModalRef = useRef(null);
  const [departmentList, setDepartmentList] = useState([]);

  const [needDepartmentListLoad, setNeedDepartmentListLoad] = useState(false);

  useEffect(() => {
    if (departmentListModalRef.current) {
      departmentListModalRef.current = new bootstrap.Modal(
        departmentListModalRef.current,
      );
    }
  }, [departmentListModalRef]);

  const getDepartmentList = (openModal = false) => {
    dispatch(fetchDepartmentList({}))
      .then((res) => {
        const statusCode = res.payload.code;
        if (statusCode.isSuccessCode) {
          const departmentList = res.payload.result;
          setDepartmentList(departmentList);
          if (openModal) {
            toggleDepartmentListModel(true);
            setNeedSearchLoad((prev) => !prev);
          }
        } else {
          console.error('fetchDepartmentList error', res);
        }
      })
      .catch((err) => {
        console.error('fetchDepartmentList error', err);
      });
  };

  const toggleDepartmentListModel = (isShow) => {
    if (departmentListModalRef) {
      if (isShow) {
        setNeedDepartmentListLoad(true);
        departmentListModalRef.current.show();
      } else {
        setNeedDepartmentListLoad(false);
        departmentListModalRef.current.hide();
      }
    }
  };

  return {
    departmentListModalRef,
    toggleDepartmentListModel,
    getDepartmentList,
    departmentList,
    needDepartmentListLoad,
    setNeedDepartmentListLoad,
  };
};
